export default __webpack_public_path__ + "static/media/t4.90427471.png";